import React, { useEffect, useState } from "react"
import withRouter from "components/Common/withRouter"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import toast from "react-hot-toast"
import { updateHomePage, viewHomePage } from "helpers/fakebackend_helper"
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput"
import ImagePopup from "pages/Home-Page/ImagePopup"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

const GosTemplate = () => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

  const [passedSteps, setPassedSteps] = useState([1])
  const [passedStepsVertical, setPassedStepsVertical] = useState([1])
  const [show, setshow] = useState([true, true, true, true])
  const [navId, setNavId] = useState()
  const [slugs, setSlugs] = useState()
  const { state } = useLocation()
  const [btn, setBtn] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const handleClose = () => setShowPopup(false)
  const [image_path, setImage_path] = useState("")

     const { slug } = useParams();

  const [tab1, setTab1] = useState({
    eng_title1: "",
    tamil_title1: "",
    eng_title2: "",
    tamil_title2: "",
    eng_title3: "",
    tamil_title3: "",
    eng_title4: "",
    tamil_title4: "",
    eng_title5: "",
    tamil_title5: "",
    eng_title6: "",
    tamil_title6: "",
  })

  const [tab2, setTab2] = useState([
    {
      id: 1,
      eng_desc1: "",
      tamil_desc1: "",
      eng_desc2: "",
      tamil_desc2: "",
      eng_desc3: "",
      tamil_desc3: "",
      eng_desc4: "",
      tamil_desc4: "",
      eng_desc5: "",
      tamil_desc5: "",
      image_path: "",
    },
  ])

  const [tab3, setTab3] = useState({
    image_path: "",
    eng_title: "",
    tamil_title: "",
  })

  const handleTab3Change = e => {
    const { name, value } = e.target
    setTab3(p => ({ ...p, [name]: value }))
  }

  const handleTab1Change = e => {
    const { name, value } = e.target
    setTab1(p => ({ ...p, [name]: value }))
  }

  const handleTab2Change = e => {
    const { name, value } = e.target
    setTab2(p => ({ ...p, [name]: value }))
  }

  const onAddFormRow = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      eng_desc1: "",
      tamil_desc1: "",
      eng_desc2: "",
      tamil_desc2: "",
      eng_desc3: "",
      tamil_desc3: "",
      eng_desc4: "",
      tamil_desc4: "",
      eng_desc5: "",
      tamil_desc5: "",
      image_path: "",
    }
    setTab2([...tab2, newRow])
  }

  const onDeleteFormRow = id => {
    const updatedRows = tab2.filter(row => row.id !== id)
    setTab2(updatedRows)
  }

  const handleInputChange = (id, name, value) => {
    const updatedRows = tab2.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab2(updatedRows)
  }

  const handleTab1Verify = () => {
    if (
      tab1.eng_title1 != "" &&
      tab1.tamil_title1 != "" &&
      tab1.eng_title2 != "" &&
      tab1.tamil_title2 != "" &&
      tab1.eng_title3 != "" &&
      tab1.tamil_title3 != "" &&
      tab1.eng_title4 != "" &&
      tab1.tamil_title4 != "" &&
      tab1.eng_title5 != "" &&
      tab1.tamil_title5 != "" &&
      tab1.eng_title6 != "" &&
      tab1.tamil_title6 != ""
    ) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab2Verify = () => {
    if (tab2.length == 0) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab3Verify = () => {
    if (tab3.tamil_title != "" && tab3.eng_title != "") {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      var modifiedSteps = [...passedStepsVertical, tab]

      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab)
        setPassedStepsVertical(modifiedSteps)
      }
    }
  }

  const [isLoading, setisLoading] = useState(false)

  const getTemplete = navigation_id => {
    let payload = new FormData()
    payload.append('navigation_template_id', slug)
    // let payload ={
    //     navigation_id:navigation_id
    // }
    viewHomePage(payload)
      .then(res => {
        let data = res?.response
        if (data?.header_json) {
          setTab1(data?.header_json)
        }

        // TAB 2
        if (data?.gos_json?.goses) {
          let arr = Object.values(data?.gos_json?.goses)
          let temp = []
          arr?.map((item, ind) => {
            temp.push({
              id: ind + 1,
              ...item,
            })
          })
          setTab2(temp)
        }

        if (data?.banner_json) {
          setTab3(data?.banner_json)
        }
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  useEffect(() => {
    if (state?.data?.id) {
      setNavId(state?.data?.id)
      getTemplete(state?.data?.slug)
      setSlugs(state?.data?.slug)
    }

    if(slug){
      getTemplete()
  }
  }, [state])

  // console.log('statestatestate', slug);

  const handleSubmitForm = () => {
    var formData = new FormData()

    formData.append('navigation_template_id', slug)

    // tab 1
    formData.append(`header_json[eng_title1]`, tab1?.eng_title1)
    formData.append(`header_json[tamil_title1]`, tab1?.tamil_title2)
    formData.append(`header_json[eng_title2]`, tab1?.eng_title2)
    formData.append(`header_json[tamil_title2]`, tab1?.tamil_title2)
    formData.append(`header_json[eng_title3]`, tab1?.eng_title3)
    formData.append(`header_json[tamil_title3]`, tab1?.tamil_title3)
    formData.append(`header_json[eng_title4]`, tab1?.eng_title4)
    formData.append(`header_json[tamil_title4]`, tab1?.tamil_title4)
    formData.append(`header_json[eng_title5]`, tab1?.eng_title5)
    formData.append(`header_json[tamil_title5]`, tab1?.tamil_title5)
    formData.append(`header_json[eng_title6]`, tab1?.eng_title6)
    formData.append(`header_json[tamil_title6]`, tab1?.tamil_title6)

    // tab 2
    tab2.map((res, i) => {
      formData.append(`gos_json[goses][${i}][eng_desc1]`, res?.eng_desc1)
      formData.append(`gos_json[goses][${i}][eng_desc2]`, res?.eng_desc2)
      formData.append(`gos_json[goses][${i}][eng_desc3]`, res?.eng_desc3)
      formData.append(`gos_json[goses][${i}][eng_desc4]`, res?.eng_desc4)
      formData.append(`gos_json[goses][${i}][eng_desc5]`, res?.eng_desc5)
      formData.append(`gos_json[goses][${i}][tamil_desc1]`, res?.tamil_desc1)
      formData.append(`gos_json[goses][${i}][tamil_desc2]`, res?.tamil_desc2)
      formData.append(`gos_json[goses][${i}][tamil_desc3]`, res?.tamil_desc3)
      formData.append(`gos_json[goses][${i}][tamil_desc4]`, res?.tamil_desc4)
      formData.append(`gos_json[goses][${i}][tamil_desc5]`, res?.tamil_desc5)
      formData.append(`gos_json[goses][${i}][image_path]`, res?.image_path)
    })

    // tab 3
    formData.append(`banner_json[image_path]`, tab3?.image_path)
    formData.append(`banner_json[eng_title]`, tab3.eng_title)
    formData.append(`banner_json[tamil_title]`, tab3?.tamil_title)

    setisLoading(true)
    updateHomePage(formData)
      .then(res => {
        setisLoading(false)
        if (res?.success) {
          toast.success("Added Success")
          getTemplete(state?.data?.slug ?? slug)
          // router(-1)
        } else {
          toast.error(res?.message ?? "somthing went wrong!")
        }
      })
      .catch(err => {
        setisLoading(false)
        toast.error(err.message)
      })
  }

  const getImg = image_ => {
    setImage_path(image_)
    setShowPopup(true)
  }

  return (
    <>
      <ImagePopup
        showPopup={showPopup}
        handleClose={handleClose}
        image_path={image_path}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem={state?.data?.type ?? ""}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <h4 className="card-title mb-4">Home</h4> */}
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="text-truncate">
                              <span className="number">1.</span>
                              Banner
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="text-truncate">
                              <span className="number">2.</span>
                              Header Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3)
                            }}
                            disabled={!(passedSteps || []).includes(3)}
                          >
                            <span className="text-truncate">
                              <span className="number">3.</span>
                              Gos Section
                            </span>
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>

                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          {/* <div className="d-flex justify-content-end w-100">
                                            <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                setshow((p) => {
                                                    const h = [...p];
                                                    h[0] = !h[0];
                                                    return h;
                                                })
                                            }}>{show[0] ? "Show" : 'Hidden'}</button>
                                        </div> */}
                          <Form>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title"
                                    onChange={handleTab3Change}
                                    value={tab3?.eng_title}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab3.tamil_title}
                                    setValue={e =>
                                      setTab3(p => ({ ...p, tamil_title: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="imag">
                                    Image <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="file"
                                    onChange={e =>
                                      setTab3(p => ({
                                        ...p,
                                        image_path: e.target.files[0],
                                      }))
                                    }
                                    className="form-control"
                                    id="imag"
                                    placeholder="Enter Your Email ID"
                                  />
                                </div>

                                {tab3?.image_path && (
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                      getImg(tab3?.image_path)
                                    }}
                                  >
                                    Preview
                                  </button>
                                )}
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>
                        <TabPane tabId={2}>
                          {/* <div className="d-flex justify-content-end w-100">
                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                    setshow((p) => {
                                        const h = [...p];
                                        h[0] = !h[0];
                                        return h;
                                    })
                                }}>{show[0] ? "Show" : 'Hidden'}</button>
                            </div> */}
                          <Form>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title 1{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title1"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title1}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title 1"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title 1
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title1}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title1: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title 2{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title2"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title2}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title 2"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title 2
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title2}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title2: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title 3{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title3"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title3}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title 3"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title 3
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title3}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title3: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title 4{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title4"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title4}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title 4"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title 4
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title4}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title4: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title 5{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title5"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title5}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title 5"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title 5
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title5}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title5: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title 6{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title6"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title6}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title 5"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title 6
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title6}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title6: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>

                        <TabPane tabId={3}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[1] = !h[1];
                                            return h;
                                        })
                                    }}>{show[1] ? "Show" : 'Hidden'}</button>
                                </div> */}

                            <Form>
                              {(tab2 || []).map((formRow, key) => (
                                <Row key={key}>
                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Desc 1{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_desc1"
                                        onChange={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "eng_desc1",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Title."
                                        value={formRow?.eng_desc1}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Desc 1{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_desc1}
                                        name={"tamil_desc1"}
                                        setValue={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "tamil_desc1",
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Desc 2{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_desc2"
                                        onChange={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "eng_desc2",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Title."
                                        value={formRow?.eng_desc2}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Desc 2{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_desc2}
                                        name={"tamil_desc2"}
                                        setValue={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "tamil_desc2",
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Desc 3{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_desc3"
                                        onChange={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "eng_desc3",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Title."
                                        value={formRow?.eng_desc3}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Desc 3{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_desc3}
                                        name={"tamil_desc3"}
                                        setValue={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "tamil_desc3",
                                            e
                                          )
                                        }
                                      />{" "}
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Desc 4{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_desc4"
                                        onChange={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "eng_desc4",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Title."
                                        value={formRow?.eng_desc4}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Desc 4{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_desc4}
                                        name={"tamil_desc4"}
                                        setValue={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "tamil_desc4",
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Desc 5{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_desc4"
                                        onChange={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "eng_desc5",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Title."
                                        value={formRow?.eng_desc5}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Desc 5{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_desc5}
                                        name={"tamil_desc5"}
                                        setValue={e =>
                                          handleInputChange(
                                            formRow.id,
                                            "tamil_desc5",
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        File (PDF){" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <div className="d-flex gap-2">
                                        <Input
                                          onChange={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "image_path",
                                              e.target.files[0]
                                            )
                                          }
                                          name="image_path"
                                          placeholder=""
                                          type="file"
                                          accept="application/pdf"
                                        />
                                        {!formRow?.image_path?.name &&
                                        formRow?.image_path != null ? (
                                          <button
                                            type="button"
                                            onClick={() => {
                                              window.open(
                                                formRow?.image_path,
                                                "_blank"
                                              )
                                            }}
                                            className=" btn btn-primary rounded"
                                          >
                                            <i
                                              className="bx bxs-download font-size-18"
                                              id="pre"
                                            />
                                          </button>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                  <Col lg={12}>
                                  {key > 0 &&  <Col
                                      lg={2}
                                      className="mb-2 align-self-center"
                                    >
                                      <div className="d-grid">
                                        <input
                                          type="button"
                                          className="btn btn-danger"
                                          value="Delete"
                                          onClick={() =>
                                            onDeleteFormRow(formRow.id)
                                          }
                                        />
                                      </div>
                                    </Col>}
                                  </Col>
                                </Row>
                              ))}

                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add GOS"
                                onClick={() => onAddFormRow()}
                              />
                            </Form>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>

                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <button
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </button>
                        </li>
                        <li
                          className={activeTab === 3 ? "next" : "next"}
                        >
                          {activeTab === 3 ? (
                            <button
                              type="button"
                              onClick={() => handleSubmitForm()}
                              className="btn btn-primary"
                            >
                              {isLoading ? (
                                <>
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                  Loading
                                </>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                if (activeTab == 1) {
                                  if (!show[0] || handleTab3Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 2) {
                                  if (!show[1] || handleTab1Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 3) {
                                  if (!show[2] || handleTab2Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                }
                                // else if (activeTab == 4) {
                                //     if (!show[0] || handleTab4Verify()) {
                                //         toggleTab(activeTab + 1)
                                //     }
                                // }
                              }}
                            >
                              Next
                            </button>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default withRouter(GosTemplate)
